<template>
  <v-app class="login-app">
    <div class="background"></div>
    <div class="main_container" :class="classRegister">
      <div class="vertical-stripe-1"></div>
      <div class="vertical-stripe-2"></div>
      <!-- DESKTOP -->
      <div class="left_login">
        <div class="content_left_login">
            <div :class="{'left_login_text': showOnboarding, 'left_login_text_not_onboarding': !showOnboarding}">
              <div class="upper_title">
                ¡Bienvenido a <span v-if="showOnboarding">Pacífico Idiomas!</span><span v-else><br>Pacífico Idiomas!</span>
              </div>
          </div>

          <div v-if="showOnboarding" class="left_onboarding">
            <div style="line-height: 24px;">
              <div class="bottom_title">Sigue estos pasos antes de rendir tu examen diagnóstico:</div>
            </div>
            <OnboardingCarousel></OnboardingCarousel>
          </div>
        </div>
      </div>
      
      <!-- MOBILE -->
      <div class="right_login">
        <div class="content_img">
          <div class="upper_image"></div>
        </div>
        <div class="right_login_text_hidden">
          <div class="upper_title">¡Bienvenido a Pacífico Idiomas!</div>
        </div>

        <div v-if="showOnboarding" class="right_login_onboarding_hidden">
          <div class="onboarding_title">
            <div class="bottom_title">Sigue estos pasos antes de rendir tu examen diagnóstico:</div>
          </div>
          <OnboardingCarousel></OnboardingCarousel>
        </div>

        <div class="container_login_register">
          <v-card class="lower_card">
            <v-tabs
              active-class="activo-blue-strong"
              fixed-tabs
              v-model="tab"
              v-if="showLogin"
            >
              <v-tab class="tabs" :href="`#tab-1`">Iniciar sesión</v-tab>
              <v-tab class="tabs" :href="`#tab-2`">Regístrate</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item :value="'tab-1'" class="container__tabs">
                <div class="title">INGRESAR a LA PLATAFORMA</div>
                <v-card-text class="form">
                  <form v-on:keyup.enter="login()">
                    <v-row>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        style="margin: 0;padding: 0;"
                      >
                        <v-text-field
                          filled
                          :error-messages="userErrors"
                          @change="$v.user.$touch()"
                          @blur="$v.user.$touch()"
                          label="Usuario"
                          @focus="$v.user.$reset()"
                          v-model="user"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        style="margin: 0;padding: 0;"
                      >
                        <v-text-field
                          :type="showPass ? 'text' : 'password'"
                          :error-messages="passwordErrors"
                          @change="$v.password.$touch()"
                          @blur="$v.password.$touch()"
                          filled
                          @focus="$v.password.$reset()"
                          label="Contraseña"
                          v-model="password"
                          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="showPass = !showPass"
                        ></v-text-field>
                      </v-col>
                      <div class="fotgot_password" @click="showRecoverPassword">
                        Olvidé mis datos de acceso
                      </div>
                      <div style="width:100%">
                        <v-btn
                          color="blue_strong uppercase fullwith"
                          @click="login"
                          :loading="loading"
                          >Ingresar</v-btn
                        >
                      </div>
                      <div class="column_data_inf0">
                        <v-icon small>info</v-icon>
                        <div class="info_text">
                          Ingresa con los datos de alumno o egresado de la
                          Universidad del Pacífico
                        </div>
                      </div>
                    </v-row>
                  </form>
                </v-card-text>
              </v-tab-item>
              <v-tab-item :value="'tab-2'" class="container__tabs">
                <user-register @send="sendRegister($event)"> </user-register>
              </v-tab-item>
            </v-tabs-items>
            <div class="restart_email" v-if="!showLogin">
              <div class="restart_email_access">Restablecer accesos</div>
              <div class="restart_email_access2">
                Introduce la dirección de correo electrónico para recibir la
                información y restablecer la contraseña.
              </div>
              <form>
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    style="margin: 0;padding: 0;"
                  >
                    <v-text-field
                      filled
                      label="Correo electrónico"
                      v-model="recoverEmail"
                    ></v-text-field>
                  </v-col>
                  <div style="width:100%">
                    <button class="btn--primary fullwith" type="button">
                      Enviar
                    </button>
                  </div>
                </v-row>
              </form>
              <div class="back_login">
                Volver a
                <span class="back_text" @click="showRecoverPassword"
                  >Iniciar sesión</span
                >
              </div>
            </div>
          </v-card>
        </div>

      </div>

    </div>
    <v-snackbar
      v-model="snackbar"
      :color="colorSnackbar"
      :timeout="timeout"
      bottom
      left
    >
      <img
        src="./../assets/images/info-white.svg"
        style="margin-right:15px"
        alt
      />
      {{ textNotification }}
      <v-btn
        style="position: relative;bottom: 12px;"
        text
        icon
        color="primary"
        @click="snackbar = false"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <div class="div-abajo">Versión: {{ applicationVersion }}</div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import axios from "../axios-auth";
import jwt from "jwt-simple";
import { required, maxLength, email } from "vuelidate/lib/validators";
import UserRegister from "@/containers/users/UserRegister";
import { version } from "../../package.json";
import OnboardingCarousel from "@/components/OnboardingCarousel.vue";

export default {
  components: {
    "user-register": UserRegister,
    OnboardingCarousel
  },
  data() {
    return {
      tab: null,
      snackbar: false,
      colorSnackbar: "#2C2C2C",
      textNotification:
        "En estos momentos no podemos validar sus datos, por favor intente luego.",
      timeout: 5000,
      user: null,
      password: null,
      emailUser: null,

      loading: false,
      showLogin: true,
      showPass: false,
      recoverEmail: null,
      classRegister: "",
      applicationVersion: version,
      showOnboarding: true,
    };
  },
  watch: {
    tab(value) {
      if (value == "tab-2") {
        this.classRegister = "main_container_extended";
      } else {
        this.classRegister = "";
      }
    }
  },
  computed: {
    ...mapState(["secretKeyJwt"]),
    userErrors() {
      const errors = [];
      if (!this.$v.user.$dirty) return errors;
      !this.$v.user.required && errors.push("Usuario es requerido");
      !this.$v.user.maxLength &&
        errors.push("El usuario no puede tener mas de 100 caracteres");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Contraseña es requerida");
      return errors;
    }
  },
  validations() {
    return {
      user: {
        required,
        maxLength: maxLength(100)
      },
      password: {
        required
      },
      emailUser: {
        email
      }
    };
  },
  async created() {
    this.aux = localStorage.getItem("token");

    let res = await axios.get(`users/visible/`);
    let data = res.data;

    if (data) {
      const isVisible = data.visible === "true" || data.visible === true;
      this.showOnboarding = isVisible;
    }

    if (this.aux) {
      this.$store.dispatch("autoLogin", this.secretKeyJwt);
      this.usuario = this.$store.state.usuario;
      this.$router.push("/principal");
    }
  },
  methods: {
    sendRegister() {
      // console.log('sendRegister');
      this.tab = "tab-1";
    },
    showRecoverPassword() {
      // this.showLogin = !this.showLogin;
      window.open("https://srvnetappseg.up.edu.pe/siserpwd/");
    },
    goToInicio() {
      this.$router.push("/principal");
    },
    validarRegistro() {
      if (this.$v.user.$invalid || this.$v.password.$invalid) {
        return true;
      } else return false;
    },
    login() {
      if (this.validarRegistro()) {
        this.$v.$touch();
        return;
      }
      this.loading = true;
      this.email = this.user;

      let arrayUser = this.email.split("@");
      if (arrayUser[0]) {
        this.user = arrayUser[0];
      }

      axios
        .post("users/login/", {
          username: this.user,
          password: this.password
        })
        .then(response => {
          this.loading = false;
          var secret = this.secretKeyJwt;
          response.data.username = this.user;
          var token = jwt.encode(response.data, secret);
          //var token = jwt.encode(response.data.student_detail, secret);
          if (token == null || token == undefined || token == "") {
            return;
          } else {
            this.$store.dispatch("guardarToken", {
              token: token,
              keyJwt: this.secretKeyJwt
            });
            this.$store.dispatch(
              "saveNotifications",
              response.data.notifications
            );
          }
          if (this.$store.state.usuario != null) {
            this.$router.push("/principal");
          }
        })
        .catch(err => {
          this.textNotification = err.response.data.message;
          this.loading = false;
          this.snackbar = true;
        });
    }
  }
};
</script>
<style lang="scss">
.theme--light.v-label {
  transform-origin: top left !important;
}
</style>
